<div class="profile-preview">
  <app-avatar class="avatar" [user]="user || guest"></app-avatar>
  @if (role$ | async; as userRole) {
    <div class="role-container">
      @if (userRole === 'admin' || userRole === 'member' || userRole === 'owner') {
        <app-badge icon="/assets/icons/user-company.svg" color="primary">{{ userRole | capitalize }}</app-badge>
      }
      @if (userRole === 'guest') {
        <app-badge icon="/assets/icons/16/guest.svg" color="grey-50">{{ userRole | capitalize }}</app-badge>
      }
      @if (userRole === 'visitor') {
        <app-badge icon="/assets/icons/incognito.svg" color="grey-50">{{ userRole | capitalize }}</app-badge>
      }
    </div>
  }
  @if (user) {
    <div class="name">{{ user.first_name }} {{ user.last_name }}</div>
  }
  @if (guest) {
    <div class="name">{{ guest.name }}</div>
  }
  <div class="email">{{ email }}</div>
  <a
    [routerLink]="['/a/people/' + (user ? 'user' : 'guest') + '/' + (user || guest)['id']]"
    target="_blank"
    appButton
    name="profile-button"
    location="profile-preview"
    shape="round"
    height="1"
    size="1"
    color="primary"
    [center]="true"
  >
    View Profile
  </a>
</div>
